export default __webpack_public_path__ + "static/media/reportsIcon.bc8fe69d.svg";